import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { defaultHandleChange } from "../../utils/handler";
import { DEFAULT_CREDENTIALS } from "../../utils/state";
import { LoginForm } from "../../components/LoginForm";
import { Snackbar } from "../../components/Snackbar";
import { THEME_SEVERITY } from "../../utils/theme";
// import { STRINGS } from "../../utils/strings";
import { useMoodleV2 } from "../../contexts/moodle";
import {
  DEFAULT_SNACKBAR,
  ERROR_CREDENTIALS,
  ERROR_EMPTY_CREDENTIALS,
  SUCCESS_CREDENTIALS,
} from "../../utils/snackbar";

import { useTheme } from "../../contexts/ThemeContext";
import "./styles.css";
import { readableColor } from "polished";
import { useConfig } from "../../contexts/config";
import LoginFormV2 from "../../components/LoginFormV2";
import Dots from "../../components/LoginFormV2/Dots";
import YoutubeComponentV2 from "../../components/VideoPlayer";
import textLangs from "../../utils/languages.json";
import ForgotPasswordForm from "../../components/LoginFormV2/ForgotPasswordForm";

const LoginV2 = () => {
  const { config } = useConfig();
  const theme = useTheme();
  const auth = useAuth();
  const { lang, dictionary } = useAuth();
  const navigate = useNavigate();
  const [credentials, setCredentials] = React.useState(DEFAULT_CREDENTIALS);
  const [loading, setLoading] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState(DEFAULT_SNACKBAR);
  const [contrastColorSecondary, setcontrastColorSecondary] = React.useState();
  const [contrastColorPrimary, setcontrastColorPrimary] = React.useState();
  const [showForcePasswordChange, setShowForcePasswordChange] = React.useState(false);
  const [showForgotPassword, setShowForgotPassword] = React.useState(false);
  const moodlev2 = useMoodleV2();
  const [showVideo, setShowVideo] = React.useState(false);
  const location = useLocation();

useEffect(() => {
  const checkScreenSize = () => {
    setShowVideo(window.innerWidth >= 1024);
  };
  
  checkScreenSize();
  window.addEventListener('resize', checkScreenSize);
  
  return () => window.removeEventListener('resize', checkScreenSize);
}, []);

  /*   React.useEffect(() => {
    //console.log(config);
    document.querySelector("#root").style.backgroundColor = "transparent";
    let bg_img = config.config.theme.background_login;
    document.body.classList.add("imagen2", "bigDesktop:bg-cover");
    // if (localStorage.getItem("token")) navigate("/listcourses");

    if (bg_img) {
      document.body.style.backgroundImage = `url(${bg_img})`;
    }
    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "imagen2",
        "bg-auto",
        "bigDesktop:bg-cover"
      );
    };
    // eslint-disable-next-line
  }, []);
 */
  React.useEffect(() => {
    console.log(theme.colors);
    //console.log(lang);
    /* if (theme && theme.colors && theme.colors.backgroundColorBodyLogin) {
      setcontrastColorSecondary(
        readableColor(theme.colors.backgroundColorBodyLogin, "#000", "#fff", false)
      );
    }
    if (theme && theme.colors && theme.colors.backgroundColorBodyLogin) {
      
      setcontrastColorPrimary(
        readableColor(theme.colors.backgroundColorBodyLogin, "#000", "#fff", false)
      );
    } */
    // eslint-disable-next-line
  }, [theme]);

  React.useEffect(() => {
    auth.logout(moodlev2);
    // eslint-disable-next-line
  }, []);

  React.useEffect(() => {
    moodlev2.setPageEmbed(null);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isEmpty = Object.values(credentials).some((value) => value === "");
    if (isEmpty) {
      setSnackbar(ERROR_EMPTY_CREDENTIALS);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
      return;
    }
    let clean_username = credentials.username.replace(/\s/g, "").toLowerCase();
    try {
      setLoading(true);
      await auth.Login({ ...credentials, username: clean_username });
      setSnackbar(SUCCESS_CREDENTIALS);
      setTimeout(() => {
        setLoading(false);
        setSnackbar(DEFAULT_SNACKBAR);
        setCredentials(DEFAULT_CREDENTIALS);
        document.body.classList.remove("imagen3");

        const fromLocation = location.state?.from;
        let target = "/listcourses";

        if (fromLocation?.pathname && fromLocation.pathname.includes("/detailcourse")) {
          target = `${fromLocation.pathname}${fromLocation.search || ""}`;
        }

        navigate(target);
      }, 1000);
    } catch (error) {
      console.log(error.message);
      setSnackbar(ERROR_CREDENTIALS);
      setLoading(false);
      setTimeout(() => {
        setSnackbar(DEFAULT_SNACKBAR);
      }, 2000);
    }
  };

  const handleChange = (e) =>
    defaultHandleChange(e, credentials, setCredentials);

  return (
    <div className="w-full h-screen bg-[#060036] flex items-center justify-center tablet:flex-row gap-36 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-8 bg-gradient-to-r from-[#44BCF9]  to-[#E63289] z-50"></div>

      {/* Contenedor Grid Principal */}
      <div className="z-10 grid w-full max-w-screen-xl grid-cols-1 laptop:grid-cols-5 gap-x-12 items-center">
        {/* --- Columna Izquierda: Login (Siempre visible) --- */}
        <div className="relative flex justify-center laptop:col-span-2 mx-12  laptop:!mr-4 laptop:!ml-8 desktop:!ml-24 ">
          <div className="glow"></div>
          <div
            style={{ padding: "2rem" }}
            className=" bg-[#8c7fc853] border-[1px] tablet:bg-[#8C7FC8] tablet:border-[0px] border-zinc-500 h-[90dvh] tablet:h-[75dvh] max-h-[1080px] rounded-[2.5rem] w-full relative z-10"
          >
            <div className="bg-[#EDEDED] p-8 rounded-[12px] shadow-lg relative h-full w-full flex flex-col" style={{overflowY: "auto"}}>
              {/* Header */}
              <div className="text-center mb-8 w-full h-[20dvh]">
                <h1 className="text-3xl font-bold text-gray-900 mb-2 hidden">
                  Aprender Steam 👋
                </h1>
                <img
                  src="/logoaprendersteamsinespacio.png"
                  // src={
                  //   theme && theme.mode === "dark"
                  //     ? config.config.theme.theme_logo_dark
                  //     : config.config.theme.theme_logo_dark
                  // }
                  alt="Logo"
                  className="w-full h-full object-contain max-h-[20dvh]"
                />
              </div>

              {/* Form */}
              <div className="flex-1 flex flex-col">
              {!showForgotPassword && !showForcePasswordChange && (
              <LoginFormV2
                handleChange={handleChange}
                credentials={credentials}
                handleSubmit={handleSubmit}
                setShowForgotPassword={setShowForgotPassword}
                loading={loading}
                />)}

                {/* Forgot Password Form */}
                  {(showForgotPassword || showForcePasswordChange) && (
                    <ForgotPasswordForm
                      onBackToLogin={() => {
                        setShowForgotPassword(false);
                        setShowForcePasswordChange(false);
                      }}
                      showForcePasswordChange={showForcePasswordChange}
                    />
                  )}
                </div>
            </div>
          </div>
          <div style={{ display: "none" }} className="absolute bottom-0 right-[-150px] laptop:right-[-128px] bigDesktop:right-[-162px] z-0 pointer-events-none laptop:!block">
            <div className="relative character-with-shadow">
              <img
                src={require("../../assets/images/Personaje5.png")}
                alt="Mascota Aprendesteam"
                className="w-[280px] laptop:w-[296px] bigDesktop:w-[400px] object-contain rotate-6 drop-shadow-lg opacity-90"
              />
            </div>
          </div>
        </div>

        {/* --- Columna Derecha: Cita y Video (Oculta en móvil) --- */}
        {showVideo && (
        <div

          className="laptop:!flex laptop:flex-col justify-center gap-8 laptop:col-span-3 h-[76dvh] max-h-[1080px] w-full"
        >
          <div
            className="laptop:!flex laptop:flex-col laptop:justify-center laptop:items-center  rounded-[2.5rem] ml-24 h-full "
          >
            <div className="px-20  max-w-[80rem] text-white grow flex flex-col justify-center">
              <p className="text-[2.4rem] text-[#EDEDED] laptop:text-[2.6rem] desktop:text-[2.7rem] bigDesktop:text-[3.2rem] font-semibold italic  font-gibson mb-4">
                 "{dictionary.Login.phrase}"
              </p>
              <p className="text-right text-[1.7rem] font-semibold font-poppins before:content-['—_']">
                Benjamin Franklin
              </p>
            </div>
            <div className="relative flex justify-center items-center aspect-video w-[90%] bigDesktop:w-[79%] bg-Desktop:max-w-[80rem]">
              <YoutubeComponentV2
                key='login-video'
                autoPlay={false}
                poster={require("../../assets/images/poster.jpg")}
                url="https://www.youtube.com/watch?v=l2DlowM6puw"
              />
              <img
                src={require("../../assets/images/MARCO PARA VIDEO.png")}
                alt="Marco video"
                className="absolute z-[999] top-0 left-0 h-full pointer-events-none aspect-video  "
              />
            </div>
          </div>
        </div>
        )}
      </div>

      <Dots />
      <Snackbar
        severity={snackbar.severity}
        visible={snackbar.visible}
        message={snackbar.message}
      />
    </div>
  );
};

export default LoginV2;
